import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { QrConstants } from 'src/app/core/services/qr-input-service/qr.constants';
import { PcSpecsService } from 'src/app/modules/details-page/services/pc-specs/pc-specs.service';

@Component({
  selector: 'app-panther-lake-specs-page',
  templateUrl: './panther-lake-specs-page.component.html',
  styleUrls: ['./panther-lake-specs-page.component.scss'],
})
export class PantherLakeSpecsPageComponent implements OnInit {
  ptlSpcesData: any;
  setFontIntelDisplayOne: boolean;
  ptlType: string;
  isArcGraphics: boolean= false;
  isSecondaryArcGraphics: boolean= false;
  nameOrder: string[] = ['processor', 'graphics', 'graphicsCard', 'os', 'memory', 'storage', 'display', 'wifi','connectivity', 'battery'];

  constructor(
    private pcSpecsService: PcSpecsService,
    private qrCodeService: QrCodeService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setFontIntelDisplayOne = this.qrCodeService?.setenusLang();
    this.pcSpecsService.pcSpecsData.subscribe((data) => {
      if (this.qrCodeService?.isPantherLakeStd) {
        this.ptlType = GlobalConstants.PANTHER_LAKE;
      } else if(this.qrCodeService?.isPantherLake12Xe) {
        this.ptlType = GlobalConstants.PANTHER_LAKE_12XE;
      }    
      this.isArcGraphics = (QrConstants.ARC_GRAPHICS.indexOf(this.qrCodeService.qrInput?.GraphicsBadge)!=-1 ||
            (QrConstants.ARC_GRAPHICS.indexOf(this.qrCodeService.qrInput?.GraphicsBadge)===-1 && this.qrCodeService.qrInput?.GraphicsBadge[0] === 'A')||
            (QrConstants.ARC_GRAPHICS.indexOf(this.qrCodeService.qrInput?.GraphicsBadge)===-1 && this.qrCodeService.qrInput?.GraphicsBadge[0] === 'B'))
            this.isSecondaryArcGraphics = ((QrConstants.ARC_GRAPHICS.indexOf(this.qrCodeService.qrInput?.SecondaryGraphicsBadge)!=-1 ||
            (QrConstants.ARC_GRAPHICS.indexOf(this.qrCodeService.qrInput?.SecondaryGraphicsBadge)===-1 && this.qrCodeService.qrInput?.SecondaryGraphicsBadge[0] === 'A')||
            (QrConstants.ARC_GRAPHICS.indexOf(this.qrCodeService.qrInput?.SecondaryGraphicsBadge)===-1 && this.qrCodeService.qrInput?.SecondaryGraphicsBadge[0] === 'B')));   
      this.ptlSpcesData = data;
      this.ptlSpcesData = this.ptlSpcesData.map((item) => ({
        ...item,
        ...(GlobalConstants.PTL_FACTTAGS.find(
          (o) => o.name === item.name
        ) || {}),
      }));
     
        for (let item of this.ptlSpcesData) {
          if(item.name === 'graphics'){
            if(!this.isArcGraphics){
               let graphicsObj = GlobalConstants.PTL_FACTTAGS.find(
              (g) => g.name === 'dedicated_graphics'
            );
            if (graphicsObj) {
              item.iconImage = graphicsObj.iconImage;
            }
            }
          }
          if(item.name === 'graphicsCard'){
            if(!this.isSecondaryArcGraphics){
               let graphicsObj = GlobalConstants.PTL_FACTTAGS.find(
              (g) => g.name === 'dedicated_graphics'
            );
            if (graphicsObj) {
              item.iconImage = graphicsObj.iconImage;
            }
            }
          }
        }
        const ordered = this.nameOrder.map(name => this.ptlSpcesData.find(item => item.name === name)).filter(Boolean);
        const unordered = this.ptlSpcesData.filter(item => !this.nameOrder.includes(item.name));
        this.ptlSpcesData = [...ordered, ...unordered];
    });
  }

  routeToTileDetailsPage(tileUrl: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>{ 
          this.router.navigate(['/specs/' + tileUrl]);
    });
  }
}
